import { render, staticRenderFns } from "./UploadRequestResultsIndex.vue?vue&type=template&id=c62d7c0a"
import script from "./UploadRequestResultsIndex.vue?vue&type=script&lang=js"
export * from "./UploadRequestResultsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports